import { getIn, useFormikContext } from 'formik'
import { customFieldTypeToFormType } from './mapper'
import type { EditableCustomFieldProps } from './typings'

export function useGetError(props: EditableCustomFieldProps) {
  const {
    field: { id: fieldId, type },
  } = props

  const fieldType: string = customFieldTypeToFormType(type)

  const fieldName: string = `customFields.${fieldType}[${fieldId}]`

  const { errors, touched } = useFormikContext()

  const errorText: string | undefined =
    touched['customFields'] == true ||
    (!!touched['customFields'] &&
      !touched['customFields']?.[fieldType]?.[fieldId] &&
      !!errors['customFields']?.[fieldType]?.[fieldId]) ||
    touched['customFields']?.[fieldType]?.[fieldId]
      ? getIn(errors, fieldName)
      : undefined

  return {
    hasError: !!errorText,
    errorText,
  }
}
